export default __webpack_public_path__ + "img/404.8c0c7494.svg";